import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Box, Grid, Paper, Typography } from '@mui/material';
import Api from 'utils/api';


type CarCountProps =  {
    status: string,
    cars: number,
    yards: number,
    onClick: () => void,
}

type DashboardData = {
    carsByStatus: {[k:string]: 0},
    yardsByStatus: {[k:string]: 0}
}

const statuses = [
    ['pending', '/cars/pending'],
    ['ready', '/cars/ready'],
    ['transit', '/cars/pending'],
    ['shipped', '/cars/shipped'],
    ['received', '/cars/received'],
    ['canceled', '/cars/canceled'],
];

const CarAggregate = () => {
    const [data, setData] = useState<DashboardData>();
    const navigate = useNavigate();

    useEffect(() => {
        Api.dashboard.get().then(res => setData(res.data));
    }, []);

    if (!data) return null;

    return (
        <>
            {statuses.map(([s, link]) => (
                <Grid key={s} item xs={4} sm={2}>
                    <CarCount
                        status={s}
                        cars={data.carsByStatus[s]}
                        yards={data.yardsByStatus[s]}
                        onClick={() => navigate(link)}
                    />
                </Grid>
            ))}
        </>
    )
};

const CarCount = ({ status, cars, yards, onClick }: CarCountProps) => {
    const {t} = useTranslation();

    return (
        <Paper
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 151,
                cursor: 'pointer',
                '&:hover': {bgcolor: 'grey.50'},
            }}
            onClick={onClick}
        >
            <Typography component="h2" variant="h6" color="primary" gutterBottom whiteSpace="nowrap">
                <Box sx={{ display: { xs: 'none', sm: 'inline-block' } }}>{t('cars')}</Box> {status === 'transit' ? 'in transit' : status}
            </Typography>
            <Typography component="p" variant={isMobile ? 'h5' : 'h3'}>
                {cars}
            </Typography>

            {yards !== undefined && (
                <Typography color="text.secondary" sx={{flex: 1}}>
                    on {yards} {yards === 1 ? 'yard' : 'yards'}
                </Typography>
            )}
        </Paper>
    )
};

export default CarAggregate;
